import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import { Api } from 'src/models/Api.model';
import CameraConnection from 'src/models/Camera/CameraConnection';
import { getLocaleCode, Language } from 'src/models/Language.model';

import useUiTranslation from 'src/hooks/useUiTranslation';

import { captureError } from 'src/utils/errorReporting';

export default function useCancelCaptureImages() {
  const { setIsCanceling } = useRemoteBoundStore();

  const { tCommon, language } = useUiTranslation();

  const handleCancelCapture = async () => {
    try {
      setIsCanceling(true);
      await CameraConnection.getInstance().existCaptureProcess();
    } catch (error) {
      const errorMessage = tCommon('message.error.failedToCancelCaptureImages');
      Api.alertBox({
        title: tCommon('bootbox.title.Error'),
        message: errorMessage,
        locale: getLocaleCode(language as Language),
        type: 'error',
      });
      captureError(error, 'Cancel capture images failed');
    }
  };

  return {
    handleCancelCapture,
  };
}
